import React, { Fragment, useEffect, useState } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { Box, Button, Stack, Checkbox, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import DialogReuse from '../../ReuseComponents/DialogReuse';
import handleClickFindTargetPath from '../../../../utils/handleClickFindTargetPath';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

function AttributeSelectionNew(props) {

    const theme = useTheme();
    const { open, setOpen, selectedNode, setNodes, nodes, setUpdateProperties, edges } = props;
    const [attributeSelected, setAttributeSelected] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [selectAllNewAttr, setSelectAllNewAttr] = useState(false);
    const [resourceLabel, setResourceLabel] = useState("");
    const [showColumnNew, setShowColumnNew] = useState(false);
    const [showColumnRemoved, setShowColumnRemoved] = useState(false);
    const [countColumn, setCountColumn] = useState(1);
    const [addedAttribute, setAddedAttribute] = useState([]);

    const handleCheckboxChange = (checked, name) => {
        const update = attributeSelected.map((attr) => {
            if (attr.name === name) {
                return {
                    ...attr,
                    checked: !checked
                }
            }
            return attr;
        })
        setAttributeSelected(update)
    };

    const handleCheckboxChangeNewAttribute = (checked, name) => {
        const update = addedAttribute.map((attr) => {
            if (attr.name === name) {
                return {
                    ...attr,
                    checked: !checked
                }
            }
            return attr;
        })
        setAddedAttribute(update)
    };

    const handleClose = () => {
        setOpen(false);
        setShowColumnNew(false);
        setShowColumnRemoved(false);
        setSelectAllNewAttr(false);
        setCountColumn(1);
    };

    const validatePrivacyAttributes = (paths, nodes, attribute_update) => {
        let privacyNodes = new Map();
        let attributeSelection = attribute_update || [];

        // ค้นหา privacy node ที่ไม่ซ้ำกัน
        for (let path of paths) {
            for (let nodeId of path.pathNodes) {
                let node = nodes.find(n => n.id === nodeId);
                if (node?.type === "privacy" && !privacyNodes.has(nodeId)) {
                    privacyNodes.set(nodeId, node);
                }
            }
        }

        // ถ้าไม่มี privacy node ให้ return []
        if (privacyNodes.size === 0) return [];

        // ตรวจสอบ attribute ที่เลือกใน privacy nodes
        let errors = [];
        for (let [nodeId, node] of privacyNodes) {
            let privacyAttributes = node.data?.general_properties?.privacies?.map(p => p.attribute?.name) || [];
            let selectedAttributes = attributeSelection.filter(attr => attr.checked).map(attr => attr.name);

            // หา attribute ที่ไม่ตรงกัน
            let unmatchedAttributes = privacyAttributes.filter(attr => !selectedAttributes.includes(attr));

            if (unmatchedAttributes.length > 0) {
                errors.push({ nodeId, attributeErrors: unmatchedAttributes });
            }
        }

        return errors;
    };

    const updateNodesWithErrors = (errors, nodes) => {
        return nodes.map(node => {
            if (node.type === "privacy") {
                const errorEntry = errors.find(error => error.nodeId.includes(node.id));
                if (errorEntry) {
                    return updateNodeWithError(node, errorEntry);
                }
                return node;
            }
            return node;
        });
    };

    const updateNodeWithError = (node, errorEntry) => {
        const errorAttributes = Array.isArray(errorEntry.attributeErrors) ? errorEntry.attributeErrors : [];
        let privacyAttributes = node.data?.general_properties?.privacies || [];

        let hasError = false;

        const updatedPrivacyAttributes = privacyAttributes.map(privacy => {
            if (privacy.attribute?.name && errorAttributes.includes(privacy.attribute.name)) {
                hasError = true;
                return { ...privacy, attributeFromSelectionError: privacy.attribute?.name };
            }
            return privacy;
        });

        // console.log("updatedPrivacyAttributes:", updatedPrivacyAttributes);

        return {
            ...node,
            data: {
                ...node.data,
                general_properties: {
                    ...node.data.general_properties,
                    privacies: updatedPrivacyAttributes
                },
                error: hasError,
                error_text: updateErrorText(node.data.error_text, hasError)
            }
        };
    }

    const updateErrorText = (errorText, hasError) => {
        const updatedErrorText = (errorText || []).filter(text => (
            text !== "Not found attribute from selection of Path."
            && text !== "Attribute no longer available. Please select another."
        ));
        if (hasError) {
            updatedErrorText.push("Attribute no longer available. Please select another.");
        }
        return updatedErrorText;
    };

    const handleSave = async () => {

        let updateAttributeSelected = attributeSelected;

        let attr_update = [];

        let update_nodes = nodes.map((node) => {
            if (node.id === selectedNode.id) {
                return {
                    ...node,
                    data: {
                        ...node.data,
                        general_properties: {
                            ...node.data.general_properties,
                            resource_schema: updateAttributeSelected
                        }
                    }
                };
            }
            return node;
        });

        if (selectedNode?.data?.general_properties?.removedColumns
            && selectedNode?.data?.general_properties?.removedColumns.length > 0) {
            const removedColumns = selectedNode.data.general_properties.removedColumns;
            updateAttributeSelected = attributeSelected.filter((attr) => {
                const isRemoved = removedColumns.some(removed => removed.name === attr.name);
                // if (isRemoved && !attr.checked) {
                if (isRemoved) {
                    return false;
                }
                return true;
            });

            // Remove the objects from removedColumns that are no longer in attributeSelected
            const updatedRemovedColumns = removedColumns.filter(removed =>
                updateAttributeSelected.some(attr => attr.name === removed.name)
            );

            update_nodes = update_nodes.map((node) => {
                if (node.id === selectedNode.id) {
                    return {
                        ...node,
                        data: {
                            ...node.data,
                            general_properties: {
                                ...node.data.general_properties,
                                resource_schema: updateAttributeSelected,
                                removedColumns: updatedRemovedColumns
                            }
                        }
                    };
                }
                return node;
            });
            // setNodes(update_nodes);
        }

        if (selectedNode?.data?.general_properties?.addedColumns
            && selectedNode?.data?.general_properties?.addedColumns.length > 0) {
            const addedColumns = addedAttribute.map(attr => {
                const { new_attr, ...rest } = attr;
                return rest;
            });
            updateAttributeSelected = updateAttributeSelected.concat(addedColumns).sort((a, b) => a.name.localeCompare(b.name));

            // Remove the objects from removedColumns that are no longer in attributeSelected
            const updatedAddedColumns = addedColumns.filter(added =>
                !updateAttributeSelected.some(attr => attr.name === added.name)
            );

            update_nodes = update_nodes.map((node) => {
                if (node.id === selectedNode.id) {
                    return {
                        ...node,
                        data: {
                            ...node.data,
                            general_properties: {
                                ...node.data.general_properties,
                                resource_schema: updateAttributeSelected,
                                addedColumns: updatedAddedColumns
                            }
                        }
                    };
                }
                return node;
            });
        };

        attr_update = updateAttributeSelected;

        const findPaths = handleClickFindTargetPath(selectedNode.id, nodes, edges);
        // console.log("handleClickFindTargetPath", findPaths);

        const privacyNodeErrors = validatePrivacyAttributes(findPaths, nodes, attr_update);
        // console.log("privacyNodeErrors", privacyNodeErrors);

        const updateNodeErrors = updateNodesWithErrors(privacyNodeErrors, update_nodes);
        // console.log("updateNodeErrors", updateNodeErrors);

        setNodes(updateNodeErrors);
        setUpdateProperties(true);
        handleClose();
    };

    const handleSelectAll = () => {
        setAttributeSelected((prevSelected) =>
            prevSelected.map((attr) => {
                if (attr.remove) {
                    return attr
                }
                return { ...attr, checked: !selectAll };
            })
        );
        setSelectAll(!selectAll);
    };

    const handleSelectAllNewAttr = () => {
        setAddedAttribute((prevSelected) =>
            prevSelected.map((attr) => {
                return { ...attr, checked: !selectAllNewAttr };
            })
        );
        setSelectAllNewAttr(!selectAllNewAttr);
    };

    const handleGetResource = () => {
        const root_node = nodes.find((node) => node.type === "root");
        const is_resource = root_node?.data?.general_properties?.resource;
        if (is_resource) {
            setResourceLabel(is_resource);
        } else {
            setResourceLabel("-");
        }
    };

    useEffect(() => {
        const handleCheckUpdate = (general_properties) => {
            let valid_attr = [];
            let count = 1;
            const { resource_schema, removedColumns, addedColumns } = general_properties;
            if (addedColumns !== undefined && addedColumns.length > 0) {
                setAddedAttribute([...addedColumns]);
                setShowColumnNew(true);
                count = count + 1;
            }
            if (removedColumns !== undefined && removedColumns.length > 0) {
                valid_attr = resource_schema.map(attr => {
                    const isRemoved = removedColumns.some(removed => removed.name === attr.name);
                    return isRemoved ? { ...attr, remove: true } : attr;
                });
                setShowColumnRemoved(true);
                count = count + 1;
            } else {
                valid_attr = resource_schema;
            }
            setAttributeSelected(valid_attr);
            setCountColumn(count);
        };
        if (open) {
            // setAttributeSelected(selectedNode?.data?.general_properties?.resource_schema);
            handleCheckUpdate(selectedNode?.data?.general_properties);
            handleGetResource();
        }
    }, [open])

    useEffect(() => {
        if (attributeSelected) {
            const attribute_selected = attributeSelected.filter((attr) => (attr.checked === true));
            if (attribute_selected.length === attributeSelected.length) {
                setSelectAll(true);
            } else {
                setSelectAll(false);
            }
        }
    }, [attributeSelected])

    return (
        <Fragment>

            <DialogReuse // Input Value
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth={countColumn > 1 ? 'md' : 'sm'}
                title={"Attribute Selection"}
                content={
                    <div>
                        <Stack
                            sx={{
                                width: '100%',
                                alignItems: 'center',
                                textAlign: 'center',
                                paddingTop: '5px',
                                paddingBottom: '10px',
                            }}
                            direction='row'
                        >
                            <Box display="flex">
                                <Typography
                                    variant="body2"
                                    display="block"
                                    color="primary"
                                    noWrap
                                    sx={{
                                        marginRight: '5px',
                                    }}
                                >
                                    Resource:
                                </Typography>
                                <Typography
                                    variant="body2"
                                    display="block"
                                    color="black"
                                    noWrap
                                    style={{
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                        maxWidth: '300px'
                                    }}
                                >
                                    {resourceLabel}
                                </Typography>
                            </Box>
                        </Stack>

                        {(countColumn === 1) && (
                            <div className={`grid grid-cols-1`}>
                                <div className='max-h-[calc(100vh-390px)] overflow-auto'>
                                    <List sx={{ padding: '0px' }}>
                                        <ListItem
                                            sx={{
                                                padding: '0px 5px 0px 20px',
                                            }}
                                        >
                                            <ListItemIcon>
                                                <Checkbox
                                                    edge="start"
                                                    checked={selectAll}
                                                    onChange={(event) => setSelectAll(event.target.checked)}
                                                    onClick={handleSelectAll}
                                                    disableRipple
                                                />
                                            </ListItemIcon>
                                            <ListItemText
                                                primary={
                                                    <Typography
                                                        variant="body2"
                                                        component={"span"}
                                                        onClick={handleSelectAll}
                                                        className='cursor-pointer'
                                                    >
                                                        Select All
                                                    </Typography>
                                                }
                                                className='ml-[-25px]'
                                            />
                                        </ListItem>
                                        {attributeSelected.map((item, index) => {
                                            return (
                                                <React.Fragment key={index}>
                                                    {(!item.remove && !item.new_attr) && (
                                                        <ListItem
                                                            sx={{
                                                                padding: '0px 5px 0px 20px',
                                                            }}
                                                        >
                                                            <ListItemIcon>
                                                                <Checkbox
                                                                    edge="start"
                                                                    checked={item.checked}
                                                                    disableRipple
                                                                    onChange={(event) => handleCheckboxChange(!event.target.checked, item.name)}
                                                                />
                                                            </ListItemIcon>
                                                            <ListItemText
                                                                primary={
                                                                    <>
                                                                        {(!item.remove && !item.new_attr) && (
                                                                            <Typography
                                                                                variant="body2"
                                                                                component={"span"}
                                                                                className='cursor-pointer'
                                                                                onClick={() => handleCheckboxChange(item.checked, item.name)}
                                                                            >
                                                                                {item.name}
                                                                            </Typography>
                                                                        )}
                                                                    </>
                                                                }
                                                                className='ml-[-25px]'
                                                            />
                                                        </ListItem>
                                                    )}
                                                </React.Fragment>
                                            )
                                        })}
                                    </List>
                                </div>
                            </div>
                        )}

                        {(countColumn === 2 || countColumn === 3) && (
                            <div className={`grid ${countColumn === 2 ? 'grid-cols-2' :
                                countColumn === 3 ? 'grid-cols-3' :
                                    'grid-cols-2' // default case
                                } border border-gray-300 rounded-md`}>
                                <div className='border-r border-gray-300'>
                                    <div className='text-center border-b border-gray-300 sticky top-0 z-10 bg-white rounded-tl-md p-1'>
                                        Existing Field
                                    </div>
                                    <div className='max-h-[calc(100vh-390px)] overflow-auto'>
                                        <List sx={{ padding: '0px' }}>
                                            <ListItem
                                                sx={{
                                                    padding: '0px 5px 0px 20px',
                                                }}
                                            >
                                                <ListItemIcon>
                                                    <Checkbox
                                                        edge="start"
                                                        checked={selectAll}
                                                        onChange={(event) => setSelectAll(event.target.checked)}
                                                        onClick={handleSelectAll}
                                                        disableRipple
                                                    />
                                                </ListItemIcon>
                                                <ListItemText
                                                    primary={
                                                        <Typography
                                                            variant="body2"
                                                            component={"span"}
                                                            onClick={handleSelectAll}
                                                            className='cursor-pointer'
                                                        >
                                                            Select All
                                                        </Typography>
                                                    }
                                                    className='ml-[-25px]'
                                                />
                                            </ListItem>
                                            {attributeSelected.map((item, index) => {
                                                return (
                                                    <React.Fragment key={index}>
                                                        {(!item.remove && !item.new_attr) && (
                                                            <ListItem
                                                                sx={{
                                                                    padding: '0px 5px 0px 20px',
                                                                }}
                                                            >
                                                                <ListItemIcon>
                                                                    <Checkbox
                                                                        edge="start"
                                                                        checked={item.checked}
                                                                        disableRipple
                                                                        onChange={(event) => handleCheckboxChange(!event.target.checked, item.name)}
                                                                    />
                                                                </ListItemIcon>
                                                                <ListItemText
                                                                    primary={
                                                                        <>
                                                                            {(!item.remove && !item.new_attr) && (
                                                                                <Typography
                                                                                    variant="body2"
                                                                                    component={"span"}
                                                                                    className='cursor-pointer'
                                                                                    onClick={() => handleCheckboxChange(item.checked, item.name)}
                                                                                >
                                                                                    {item.name}
                                                                                </Typography>
                                                                            )}
                                                                        </>
                                                                    }
                                                                    className='ml-[-25px]'
                                                                />
                                                            </ListItem>
                                                        )}
                                                    </React.Fragment>
                                                )
                                            })}
                                        </List>
                                    </div>
                                </div>
                                {showColumnNew && (
                                    <div className='border-r border-gray-300'>
                                        <div className='text-center border-b border-gray-300 sticky top-0 z-10 bg-white p-1 rounded-tr-md'>
                                            New Field
                                        </div>
                                        <div className='max-h-[calc(100vh-390px)] overflow-auto'>
                                            <List sx={{ padding: '5px 5px 5px 20px' }}>
                                                <ListItem
                                                    sx={{
                                                        padding: '0px',
                                                    }}
                                                >
                                                    <ListItemIcon>
                                                        <Checkbox
                                                            edge="start"
                                                            checked={selectAllNewAttr}
                                                            onChange={(event) => setSelectAllNewAttr(event.target.checked)}
                                                            onClick={handleSelectAllNewAttr}
                                                            disableRipple
                                                        />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary={
                                                            <Typography
                                                                variant="body2"
                                                                component={"span"}
                                                                onClick={handleSelectAllNewAttr}
                                                                className='cursor-pointer'
                                                            >
                                                                Select All
                                                            </Typography>
                                                        }
                                                        className='ml-[-25px]'
                                                    />
                                                </ListItem>
                                                {addedAttribute.map((item, index) => {
                                                    return (
                                                        <React.Fragment key={index}>
                                                            {item.new_attr && (
                                                                <ListItem
                                                                    sx={{
                                                                        padding: '0px',
                                                                    }}
                                                                >
                                                                    <ListItemIcon>
                                                                        <Checkbox
                                                                            edge="start"
                                                                            checked={item.checked}
                                                                            disableRipple
                                                                            onChange={(event) => handleCheckboxChangeNewAttribute(!event.target.checked, item.name)}
                                                                        />
                                                                    </ListItemIcon>
                                                                    <ListItemText
                                                                        primary={
                                                                            <>
                                                                                {item.new_attr && (
                                                                                    <Typography
                                                                                        variant="body2"
                                                                                        component={"span"}
                                                                                        className='cursor-pointer'
                                                                                        onClick={() => handleCheckboxChangeNewAttribute(item.checked, item.name)}
                                                                                    >
                                                                                        {item.name}
                                                                                    </Typography>
                                                                                )}
                                                                            </>
                                                                        }
                                                                        className='ml-[-25px]'
                                                                    />
                                                                </ListItem>
                                                            )}
                                                        </React.Fragment>
                                                    )
                                                })}
                                            </List>
                                        </div>
                                    </div>
                                )}
                                {showColumnRemoved && (
                                    <div>
                                        <div className='text-center border-b border-gray-300 sticky top-0 z-10 bg-white rounded-tr-md p-1'>
                                            Removed Field
                                        </div>
                                        <div className='max-h-[calc(100vh-390px)] overflow-auto'>
                                            <List>
                                                {attributeSelected.map((item, index) => {
                                                    return (
                                                        <React.Fragment key={index}>
                                                            {item.remove && (
                                                                <ListItem
                                                                    sx={{
                                                                        padding: '0px 5px 0px 20px',
                                                                    }}
                                                                    disabled
                                                                >
                                                                    <ListItemIcon>
                                                                        <Checkbox
                                                                            edge="start"
                                                                            checked={item.checked}
                                                                            disableRipple
                                                                            // onChange={(event) => handleCheckboxChange(!event.target.checked, item.name)}
                                                                            disabled
                                                                        />
                                                                    </ListItemIcon>
                                                                    <ListItemText
                                                                        primary={
                                                                            <>
                                                                                {item.remove && (
                                                                                    <Typography
                                                                                        variant="body2"
                                                                                        component={"span"}
                                                                                    // onClick={() => handleCheckboxChange(item.checked, item.name)}
                                                                                    >
                                                                                        {item.name}
                                                                                    </Typography>
                                                                                )}
                                                                            </>
                                                                        }
                                                                        className='ml-[-25px]'
                                                                    />
                                                                </ListItem>
                                                            )}
                                                        </React.Fragment>
                                                    )
                                                })}
                                            </List>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}

                    </div>
                }
                actions={
                    <Box>
                        <Button variant="contained" onClick={() => handleSave()}>Save</Button>
                    </Box>
                }
            />

        </Fragment>
    )
}

export default AttributeSelectionNew